var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 9.86041C6.91644 14.0343 10.3264 17.3528 14.566 19.1518L15.2456 19.4546C16.8004 20.1473 18.6282 19.621 19.5765 18.2075L20.4646 16.8838C20.7533 16.4535 20.6654 15.8738 20.262 15.5484L17.2502 13.1186C16.8078 12.7617 16.1573 12.8448 15.8189 13.3015L14.8871 14.5588C12.4963 13.3794 10.5553 11.4384 9.37595 9.04756L10.6332 8.11584C11.0899 7.77741 11.173 7.1269 10.8161 6.68452L8.38623 3.67258C8.06088 3.26929 7.48138 3.18133 7.05101 3.4699L5.71817 4.36359C4.29582 5.3173 3.77244 7.16015 4.48118 8.7191L4.99926 9.85871L5.00004 9.86041Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterphone);
export default __webpack_public_path__ + "static/media/footerphone.4f21cb5ffb3fe0bcb3a27c8e2ce978fc.svg";
export { ForwardRef as ReactComponent };